//Default Note Template to initialize editable items when creating a new entity in the editor
//Frozen so this default can't be changed by users.
export const defaultItem_NoteTemplate = Object.freeze({
    label: 'New Note Template',
    title: 'New Note Template',
    sections: [],
    params: [],
    promptIds: [],
    advisorAppearance: {},
    _variableIds: [],
    _logTemplateIds: [],
});
//# sourceMappingURL=consts.js.map